export default __webpack_public_path__ + "static/media/user.a4305d82.svg";